import { DestroyRef, Directive, EffectRef, effect, inject, Injector, input, isSignal, runInInjectionContext, Signal, untracked } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[mustEqual]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EqualValidatorDirective, multi: true }],
    standalone: true
})

export class EqualValidatorDirective implements Validator {
    readonly mustEqual = input<Signal<number> | number | undefined>(undefined);

    private readonly destroyRef = inject(DestroyRef);
    private readonly injector = inject(Injector);
    private validatorDepsEffect?: EffectRef;

    constructor() {
        this.destroyRef.onDestroy(() => this.validatorDepsEffect?.destroy());
    }

    registerOnValidatorChange(fn: () => void): void {
        this.validatorDepsEffect?.destroy();
        runInInjectionContext(this.injector, () => {
            this.validatorDepsEffect = effect(() => {
                const bound = this.mustEqual();
                if (isSignal(bound)) {
                    bound();
                }
                untracked(() => fn());
            });
        });
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const mustEqual = this.resolveMustEqualValue();
        if (mustEqual == null || mustEqual == undefined) {
            return null;
        }

        const error: ValidationErrors = control.value != mustEqual
            ? { "mustEqual": `Control value does not equal specified value` }
            : null;
        return error;
    }

    private resolveMustEqualValue(): number | undefined {
        const bound = this.mustEqual();
        if (bound == null) {
            return undefined;
        }

        return isSignal(bound) ? bound() : bound;
    }
}
